import { TAppAction, AppActionTypes } from './actions';
import { IAppState } from './appContext';

export const appReducer = (state: IAppState, action: TAppAction): IAppState => {
	switch (action.type) {
		case AppActionTypes.ADD_APP_ERROR:
			return {
				...state,
				appErrors: [...state.appErrors, action.payload.error],
			};
		case AppActionTypes.REMOVE_APP_ERROR:
			return {
				...state,
				appErrors: action.payload.appErrors,
			};
		case AppActionTypes.SHOW_LOADER:
			return {
				...state,
				isLoading: true,
			};
		case AppActionTypes.HIDE_LOADER:
			return {
				...state,
				isLoading: false,
				uploadProgress: null,
			};
		case AppActionTypes.SET_UPLOAD_PROGRESS:
			return {
				...state,
				uploadProgress: action.payload.uploadProgress,
			};
		case AppActionTypes.SET_ENTITY_NAME_FOR_HEADER:
			return {
				...state,
				entityNameForHeader: action.payload.entityNameForHeader,
			};
		case AppActionTypes.LOG_IN:
			return {
				...state,
				loggedUser: action.payload.loggedUser,
			};
		case AppActionTypes.SET_NOTIFICATIONS_CONNECTION:
			return {
				...state,
				notificationsConnection: action.payload.notificationsConnection,
			};
		case AppActionTypes.SET_PATHNAMES_HISTORY:
			return {
				...state,
				pathnamesHistory: action.payload.pathnamesHistory,
			};
		case AppActionTypes.SET_FEATURE_FLAGS:
			return {
				...state,
				featureFlags: action.payload.featureFlags,
			};
		default:
			return state;
	}
};
